// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__uk8XV","products":"Search_products__61a++","header":"Search_header__7DLwQ","goBack":"Search_goBack__I7Yew","title":"Search_title__6iJfj"};